import React, { useState, useEffect } from 'react'
import Header from '../users/Header'
import NavHeader from '../users/NavHeader'
import { UserAuth } from '../../context/AuthContext'
import Footer from './../users/Footer'
import { RiVipCrown2Line } from 'react-icons/ri';
import { NavLink, useLocation } from 'react-router-dom';
import { SiBinance } from 'react-icons/si';
import Conn from './Conn';

const Subscribe = () => {
  const { user } = UserAuth();
  const uname = user.displayName;

  const [error, setError] = useState('');
  const [loading, setLoading] = useState();

  const [showNotification, setShowNotification] = useState(false);
  const [timeoutId, setTimeoutId] = useState(null);
  useEffect(() => {
    return () => {
      clearTimeout(timeoutId);
    };
  }, [timeoutId]);
  const location = useLocation();
  return (
    <div className="antialiased bg-primary md:block md:bg-indigo-50" style={{ backgroundImage: `url('/images/bg-body.png')` }} relative>
      <NavHeader />
      <div className="max-w-[600px] mx-auto min-h-screen bg-slate-100 shadow-2xl relative">
        <Header />
        {loading && (
          <div className="absolute top-0 left-0 right-0 bottom-0 bg-black opacity-60 flex items-center justify-center z-50">
            <img src='/logo192.png' alt="Loading..." className="w-10 h-10" />
          </div>
        )}
        {showNotification && (
          <div className="px-4 fixed bottom-[50px] w-full max-w-[600px] transform mb-8 animate-fade-in animate-slide-up z-50">
            <div className="bg-stone-900 text-white w-full rounded p-4 text-sm font-semibold flex justify-between">
              {error}
              <span className="text-primary cursor-pointer" onClick={() => setShowNotification(false)}>Ok</span>
            </div>
          </div>
        )}
        <div className='pt-3 pb-[96px]'>

          <div className='bg-white'>
            <div className='px-4 pt-4 pb-2 md:p-4 flex justify-between items-center'>
              <div className='flex items-center'>
                <span className="mr-2">
                  <RiVipCrown2Line className='h-[14px] w-[14px] md:h-[16px] md:w-[16px]' />
                </span>
                <h1 className='font-semibold text-base md:text-lg'>Upgrade Plan</h1>
              </div>
              <div className='text-primary md:font-semibold font-bold text-sm md:text-base'>
                Pelajari
              </div>
            </div>
            <div className='flex justify-start items-center px-4'>
              <NavLink to='/upgrade' exact={true}>
                <div className={`flex flex-col items-center px-2 z-100 pb-4 ${location.pathname === '/upgrade' ? 'border-b-4 border-primary' : 'border-b-4 border-slate-100'} cursor-pointer`}>
                  <div className='w-[64px]'>
                    <span className='w-full h-full flex items-center justify-center'>
                      <SiBinance size='22px' className='fill-yellow-500' />
                    </span>
                  </div>
                  <div className='text-xs mt-3 text-center  text-zinc-800'>
                    Crypto Wallet
                  </div>
                </div>
              </NavLink>
            </div>
            <div className="bottom-0 bg-slate-100 h-[4px] z-10 -mt-1"></div>
            <div className='pb-10'>
              <div className='flex justify-between items-center'>
                <div className='flex items-center p-4'>
                  <span className='mr-2'>
                    <SiBinance size='20' />
                  </span>
                  <h1 className='font-semibold text-base'>Crypto Wallet</h1>
                </div>
              </div>
              <div className=''>
                <h1 className='text-3xl text-green-700 font-semibold p-4 text-center'>Connect a wallet</h1>
                <Conn/>
              </div>
            </div>
          </div>
        </div >
      </div >
      <Footer />
    </div >
  )
}

export default Subscribe
